import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  Tabs,
  Collapse,
  Tag,
  Space,
  Button,
  Radio,
  Divider,
  Drawer,
} from "antd";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "antd/dist/reset.css"; // optional if you're using Ant Design v5 styles
import { useSelector } from "react-redux";
import CustomThemeDrawer from "../../../../../Elements/CustomThemeDrawer";
import MeterStatusView from "./MeterStatusView";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { calculateDateRangeFromDate } from "../../../../../../Utils/DateConverstion";
import NotAuthenticated from "../../../../../CommonScreens/NotAuthenicated";
import {
  EnvironmentOutlined,
} from "@ant-design/icons";
import MeterModal from "./PopUpModal";
const { TabPane } = Tabs;
const { Panel } = Collapse;

const StatusView = () => {
  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  const { makeRequest } = useStoreUpdaterWithAPI();
  //console.log(color);
  const { isdarkMode } = mode;
  const [open, setOpen] = useState(false);
  const [cardData, setcardData] = useState([
    // {
    //   statusID: 1,
    //   statusName: "Outlet",
    //   totalCount: 3,
    //   liveCount: 3,
    //   offCount: 0,
    // },
    // {
    //   statusID: 2,
    //   statusName: "Device",
    //   totalCount: 6,
    //   liveCount: 5,
    //   offCount: 1,
    // },
  ]);
  const [deviceStatus, setDeviceStatus] = useState([]);
  const [groupStatus, setGroupStatus] = useState([
    // {
    //   groupID: 2,
    //   groupName: 'TamilNadu',
    //   activeDevice: 4,
    //   inActiveDevice: 0,
    //   alarm: 0
    // },
    // {
    //   groupID: 3,
    //   groupName: 'Karnataka',
    //   activeDevice: 2,
    //   inActiveDevice: 0,
    //   alarm: 0
    // },
  ]);
  const [rowDeviceData, setRowDeviceData] = useState([]);
  const [rowGroupData, setRowGroupData] = useState([]);
  const [parameters, setParameters] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [activeKey, setActiveKey] = useState(null);
  const [isIdleModalOpen, setIsIdleModalOpen] = useState(false);
const [isInactiveModalOpen, setIsInactiveModalOpen] = useState(false);
  const[modalData,setModalData]=useState({})
const getModalData=(status)=>{

  makeRequest({
type: APIConstants.GET,
url: `${APIConstants.GET_METER_POPUP_DETAILS}?SectionID=1&Status=${status}&FromDate=2025-11-20&ToDate=2025-11-25`,
}).then((res) => {
  if (res) {
const groupedBySite = res?.reduce((acc, meter) => {
  const siteName = meter.sitename || "Unknown Site";
  if (!acc[siteName]) acc[siteName] = [];
  acc[siteName].push(meter);
  return acc;
}, {});
setModalData(groupedBySite)
}
});
}
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setRefetch((prev) => !prev); // Toggle to trigger effect
    }, 60000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);
  //console.log(refetch);

  const getGroupStatusData = () => {
    // //console.log();
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_GROUP_DEVICE_STATUS}?timespan=5`,
    }).then((res) => {
      //console.log("Master details :", res);
      if (res) {
        setGroupStatus(res);
      }
    });
  };
  const getDeviceStatusData = () => {
    // //console.log();
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_CONVERTER_DEVICE_STATUS}?timespan=5`,
    }).then((res) => {
      //console.log("Master details :", res);
      if (res) {
        setDeviceStatus(res);
      }
    });
  };
  const getStatusData = () => {
    // //console.log();
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_CONVERTER_AND_DEVICE_STATUS}?timespan=5`,
    }).then((res) => {
      //console.log("Master details :", res);
      if (res) {
        setcardData(res);
      }
    });
  };
  useEffect(() => {
    getStatusData();
    //console.log(activeTab);
    const deviceItem = localStorage.getItem("deviceItem");
    // const deviceItem=JSON?.parse(localStorage.getItem('deviceItem'));
    //console.log(deviceItem);
    if (deviceItem != "") {
      //console.log(JSON.parse(deviceItem));
    }
    if (activeTab == 1) {
      getDeviceStatusData();
      if (deviceItem != "" && deviceItem != null && !open) {
        handleRowClick(JSON.parse(deviceItem));
      }
    }
    if (activeTab == 2) {
      getGroupStatusData();
      if (deviceItem != "" && deviceItem != null && !open) {
        handleRowClick(JSON.parse(deviceItem));
      }
    }
  }, [refetch, activeTab]);


  const getStatusTag = (status) => {
    //console.log(status);
    switch (status) {
      case "ON":
        return <Tag color="green">On</Tag>;
      case "idle":
        return <Tag color="orange">Idle</Tag>;
      case "OFF":
        return <Tag color="red">Off</Tag>;
      default:
        return <Tag>{status}</Tag>;
    }
  };

  const deviceColumnDefs = useMemo(
    () => [
      // {
      //   headerName: "Subgroup",
      //   field: "subgroup",
      //   width: 100,
      //   rowSpan: (params) => {
      //     const currentIndex = params.node.rowIndex;
      //     const currentSubgroup = params.data?.subgroup;
      //     const api = params.api;

      //     // Only calculate span if this is the first occurrence
      //     const previousRow = api.getDisplayedRowAtIndex(currentIndex - 1);
      //     if (previousRow?.data?.subgroup === currentSubgroup) return 0;

      //     // Count how many consecutive rows have the same subgroup
      //     let span = 1;
      //     for (let i = currentIndex + 1; i < api.getDisplayedRowCount(); i++) {
      //       const nextRow = api.getDisplayedRowAtIndex(i);
      //       if (nextRow?.data?.subgroup === currentSubgroup) {
      //         span++;
      //       } else {
      //         break;
      //       }
      //     }
      //     return span;
      //   },
      //   cellClass: "subgroup-cell",
      //   suppressMovable: true,
      // },
      { headerName: "Device ID", field: "meterid", width: 80, flex: 1 },
      { headerName: "Device Name", field: "metername", width: 130, flex: 1 },
      {
        headerName: "Status",
        field: "meterStatus",
        width: 100,
        flex: 1,
        cellRenderer: ({ value }) => getStatusTag(value),
      },
      { headerName: "VLL", field: "vllAvg", width: 110, flex: 1 },
      { headerName: "I Avg", field: "iavg", width: 110, flex: 1 },
      { headerName: "kWT", field: "kwt", width: 110, flex: 1 },
      { headerName: "kVAT", field: "kvat", width: 110, flex: 1 },
      { headerName: "PFT", field: "pft", width: 110, flex: 1 },
      // { headerName: "New Alarms", field: "alarms", width: 110 ,flex:1},
      {
        headerName: "Last Comm.",
        field: "createdon",
        flex: 1,
        minWidth: 220,
        valueFormatter: (params) => {
          return params.value ? params.value.replace("T", " ") : "";
        },
      },
    ],
    []
  );
  const groupColumnDefs = useMemo(
    () => [
      //     {
      //   headerName: "Subgroup",
      //   field: "subGroupID", // Use consistent field name
      //   width: 100,
      //   rowSpan: (params) => {
      //     const currentIndex = params.node.rowIndex;
      //     const currentSubgroup = params.data?.subGroupID;
      //     //console.log(currentSubgroup)
      //     const api = params.api;

      //     // Only calculate span if this is the first occurrence
      //     const previousRow = api.getDisplayedRowAtIndex(currentIndex - 1);
      //     if (previousRow?.data?.subGroupID === currentSubgroup) return 0;

      //     // Count how many consecutive rows have the same subgroup
      //     let span = 1;
      //     for (let i = currentIndex + 1; i < api.getDisplayedRowCount(); i++) {
      //       const nextRow = api.getDisplayedRowAtIndex(i);
      //       if (nextRow?.data?.subGroupID === currentSubgroup) {
      //         span++;
      //       } else {
      //         break;
      //       }
      //     }
      //     return span;
      //   },
      //   cellClass: "subgroup-cell",
      //   suppressMovable: true,
      // },
      // { headerName: "Sub Group Name", field: "subGroupName", width: 80,flex:1 },
      { headerName: "Device ID", field: "meterid", width: 80, flex: 1 },
      { headerName: "Device Name", field: "metername", width: 130, flex: 1 },
      {
        headerName: "Status",
        field: "meterStatus",
        width: 100,
        flex: 1,
        cellRenderer: ({ value }) => getStatusTag(value),
      },
      { headerName: "VLL", field: "vllAvg", width: 110, flex: 1 },
      { headerName: "I Avg", field: "iavg", width: 110, flex: 1 },
      { headerName: "kWT", field: "kwt", width: 110, flex: 1 },
      { headerName: "kVAT", field: "kvat", width: 110, flex: 1 },
      { headerName: "PFT", field: "pft", width: 110, flex: 1 },
      // { headerName: "New Alarms", field: "alarms", width: 110 ,flex:1},
      {
        headerName: "Last Comm.",
        field: "createdon",
        flex: 1,
        minWidth: 220,
        valueFormatter: (params) => {
          return params.value ? params.value.replace("T", " ") : "";
        },
      },
    ],
    []
  );

  const handleParameters = (event) => {
    //console.log(event.data);
    //console.log("Full rowDeviceData:", rowDeviceData);
    setParameters(event?.data);
    setOpen(true);
  };

  const handleRowClick = (data) => {
    //console.log("Row clicked:", data);
    if (data && (data.groupID || data.converterID)) {
      //console.log(activeTab);
      const currentDate = new Date();
      //console.log(currentDate);
      const { from, to } = calculateDateRangeFromDate(currentDate, 15, 2);
      //console.log(from, to);
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.GET_CONVERTER_DEVICE_DETAILS}?SectionID=${activeTab == 1 ? 1 : 2}&ConverterorGroupID=${data.converterID || data.groupID}&FromDate=${from}&ToDate=${to}`,
      }).then((res) => {
        //console.log("Master details :", res);
        if (res != null) {
          setRowDeviceData(res);
        }
      });
    }
  };

  //console.log(cardData);
  //console.log(deviceStatus);

  const handleCollapseChange = (key, deviceItem) => {
    if (key != activeKey) {
      setActiveKey(key);
      //console.log(deviceItem);
      localStorage.setItem("deviceItem", JSON.stringify(deviceItem));
      handleRowClick(deviceItem);
      //console.log("Expanded panel index:", key);
    } else {
      setActiveKey(null);
      localStorage.setItem("deviceItem", JSON.stringify({}));
    }
  };
  //console.log(parameters);

  const deviceData = rowDeviceData;

  // Grouping data by subGroupID
  const groupedData = deviceData.reduce((acc, item) => {
    const groupId = item.subGroupID;
    if (!acc[groupId]) {
      acc[groupId] = [];
    }
    acc[groupId].push(item);
    return acc;
  }, {});

const roundToTwo = (num) => {
  if (isNaN(num)) return 0; // safety check
  return Math.round((num + Number.EPSILON) * 100) / 100;
};

  const SubGroupTable = ({ subGroupID, meters }) => {
    console.log(meters);
    const total = (meters)=>{
      let data = 0;
      meters.map((i)=>( 
        data=data+i.kwt 
      ))
      return roundToTwo(data);
    }
    console.log(total(meters))
    return (
      <div style={{ marginBottom: "0px" }}>
        <h2
          className="w-full text-md border rounded-lg py-5 bg-slate-50 pl-5"
          style={{ margin: "0px 0", color: "#2e7d32" }}
        >
          Subgroup: {meters[0]?.subGroupName} ({total(meters)})
        </h2>
        <div
          style={{
            "--ag-header-background-color": color.themeConfig.colorPrimary,
            "--ag-header-foreground-color": "#fff",
            "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
            height: "300px",
            width: "100%",
            overflowY: "auto",
          }}
        >
          <AgGridReact
            rowData={meters}
            columnDefs={groupColumnDefs}
            // domLayout="autoHeight"
            //  rowData={rowDeviceData}
            domLayout="normal"
            // columnDefs={groupColumnDefs}
            onRowClicked={handleParameters}
          />
        </div>
      </div>
    );
  };
  return (
    <div className="p-4 overflow-hidden">
      <div className="flex justify-between mb-2">
        <h1
          className={` ${isdarkMode ? "text-white" : "text-black"} text-2xl font-semibold mb-4`}
        >
          Status View
        </h1>
        <Tag className="animated-tag w-28 text-lg">
          <EnvironmentOutlined className="mr-1" />
          Live
        </Tag>
      </div>
      <div className="grid grid-cols-1 gap-4 mb-6 md:grid-cols-2">
        {cardData.map((card, i) => (
          <Card key={i} className="rounded-xl" bodyStyle={{ padding: 0 }}>
            <div className="flex justify-between items-center bg-green-200 p-5 rounded-xl">
              <div className="flex flex-col justify-center items-center  flex-1">
                <div className="text-black text-xl">{card.statusName}</div>
                <div className="text-xl font-bold ">
                  {card.totalCount.toString().padStart(2, "0")}
                </div>
              </div>
              {/* <Divider type="vertical"/> */}
              <span className="border-r-2 h-10 border-gray-400 rounded-xl " />

              <div className="flex-1 flex flex-col justify-center items-center ">
                <div className="text-black text-xl">Active</div>
                <div className="text-green-600 text-xl font-bold">
                  {" "}
                  {card.liveCount.toString().padStart(2, "0")}
                </div>
              </div>
              <span className="border-r-2 h-10 border-gray-400 rounded-xl" />
            {card.statusName=='Device'&&
<>
<div onClick={()=>{setIsIdleModalOpen(true)
                        getModalData(1)
                      }} className="flex-1 flex flex-col justify-center items-center cursor-pointer ">
  <div className="text-black text-xl">Idle</div>
  <div className="text-green-600 text-xl font-bold">
    {" "}
    {card.idleCount.toString().padStart(2, "0")}
  </div>
</div>
<span className="border-r-2 h-10 border-gray-400 rounded-xl" />
</>
}

              <div  onClick={()=>{if(i===1)setIsInactiveModalOpen(true)
                    getModalData(0)} } className="flex flex-col justify-center items-center pr-0 md:pr-10 flex-1 cursor-pointer">
                <div className="text-black text-xl ">Inactive</div>
                <div className="text-red-600 text-xl font-bold">
                  {" "}
                  {card.offCount.toString().padStart(2, "0")}
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
      <Radio.Group
        value={activeTab}
        onChange={(e) => {
          setActiveKey(null);
          setActiveTab(e.target.value);
        }}
        style={{ marginBottom: 16 }}
      >
        <Radio.Button value="1">Area Wise</Radio.Button>
        <Radio.Button value="2">Group Wise</Radio.Button>
      </Radio.Group>
      {activeTab == "1" && (
        <div className="flex-col gap-4 flex overflow-x-scroll md:overflow-x-hidden ">
          {deviceStatus &&
            deviceStatus.map((device, i) => (
              <Collapse
                accordion
                activeKey={activeKey}
                onChange={() => handleCollapseChange(i, device)}
                key={i}
                className={` ${device.activeDevice ? "border-l-green-500" : "border-l-red-500"} border-l-4 border-y-0 rounded-md  custom-collapse`}
                bodyStyle={{ padding: 0 }}
              >
                <Panel
                  className={`    rounded-t-xl ${isdarkMode ? "dark-collapse" : "light-collapse"}`}
                  header={
                    <div className="flex justify-between items-center">
                      <span className="min-w-[100px]">
                        {device.converterName}
                      </span>
                      <Tag className="border-0 p-1 px-2" color="green">
                        ✔ Active {device.activeDevice}
                      </Tag>
                      <Tag className="border-0 p-1 px-2" color="red">
                        ✘ Inactive {device.inActiveDevice}
                      </Tag>
                      <Tag className="border-0 p-1 px-2" color="purple">
                        🔔 Alarm {device.alarm}
                      </Tag>
                    </div>
                  }
                  key={i}
                  bodyStyle={{ padding: 0 }}
                >
                  <div
                    className={` ${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"} cursor-pointer`}
                    style={{
                      "--ag-header-background-color":
                        color.themeConfig.colorPrimary,
                      "--ag-header-foreground-color": "#fff",
                      "--ag-header-group-bg":
                        color.themeConfig.colorPrimaryShade, // custom var
                      height: "300px",
                      width: "100%",
                      overflowY: "auto",
                    }}
                  >
                    <AgGridReact
                      suppressRowTransform={true}
                      rowData={rowDeviceData}
                      domLayout="normal"
                      columnDefs={deviceColumnDefs}
                      onRowClicked={handleParameters}
                      className="mt-2"
                    />
                  </div>
                </Panel>
              </Collapse>
            ))}
        </div>
      )}
      {activeTab == "2" && (
        <div className="flex-col gap-4 flex overflow-x-scroll md:overflow-x-hidden">
          {groupStatus &&
            groupStatus.map((device, i) => (
              <Collapse
                accordion
                activeKey={activeKey}
                onChange={() => handleCollapseChange(i, device)}
                key={i}
                className={` ${device.activeDevice ? "border-l-green-500" : "border-l-red-500"} border-l-4 border-y-0 rounded-md  custom-collapse`}
                bodyStyle={{ padding: 0 }}
              >
                <Panel
                  className={`    rounded-t-xl ${isdarkMode ? "dark-collapse" : "light-collapse"}`}
                  header={
                    <div className="flex justify-between items-center">
                      <span className="min-w-[100px]">{device.groupName}</span>
                      <Tag className="border-0 p-1 px-2" color="green">
                        ✔ Active {device.activeDevice}
                      </Tag>
                      <Tag className="border-0 p-1 px-2" color="red">
                        ✘ Inactive {device.inActiveDevice}
                      </Tag>
                      <Tag className="border-0 p-1 px-2" color="purple">
                        🔔 Alarm {device.alarm}
                      </Tag>
                    </div>
                  }
                  key={i}
                  bodyStyle={{ padding: 0 }}
                >
                  <div
                    className={` ${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"} cursor-pointer`}
                    style={{
                      "--ag-header-background-color":
                        color.themeConfig.colorPrimary,
                      "--ag-header-foreground-color": "#fff",
                      "--ag-header-group-bg":
                        color.themeConfig.colorPrimaryShade, // custom var
                      height: "300px",
                      width: "100%",
                      overflowY: "auto",
                    }}
                  >
                    {/* <AgGridReact 
                        suppressRowTransform={true} 
                        // rowData={i==0?tableData:tableData2} domLayout="normal" columnDefs={groupColumnDefs}
                        rowData={rowDeviceData} domLayout="normal" columnDefs={groupColumnDefs}
                        onRowClicked={handleParameters}  className="mt-2"/> */}
                    {Object.entries(groupedData).map(([subGroupID, meters]) => (
                      <SubGroupTable
                        key={subGroupID}
                        subGroupID={subGroupID}
                        meters={meters}
                      />
                    ))}
                  </div>
                </Panel>
              </Collapse>
            ))}
        </div>
      )}

      {/* </Tabs> */}
      <MeterStatusView
        parameters={parameters}
        data={rowDeviceData}
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
        width={"80%"}
      />


<MeterModal isIdleModalOpen={isIdleModalOpen} isInactiveModalOpen={isInactiveModalOpen} setIsIdleModalOpen={setIsIdleModalOpen} setIsInactiveModalOpen={setIsInactiveModalOpen} modalData={modalData}/>

    </div>
  );
};

export default StatusView;
